var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "menu-button",
      attrs: { "aria-expanded": _vm.menuActive.toString() },
      on: {
        click: function($event) {
          return _vm.toggleMenu()
        }
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("span", {
        staticClass: "menu-label",
        domProps: { textContent: _vm._s(_vm.menuActive ? "Close" : "Menu") }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "menu-button__hamburger" }, [
      _c(
        "span",
        { staticClass: "menu-button__bread menu-button__bread--top" },
        [
          _c("span", {
            staticClass:
              "menu-button__bread-crust menu-button__bread-crust--top"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "menu-button__bread menu-button__bread--bottom" },
        [
          _c("span", {
            staticClass:
              "menu-button__bread-crust menu-button__bread-crust--bottom"
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d5141be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5141be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuButton.vue
// module id = null
// module chunks = 